module.exports = __webpack_public_path__ + "img/MO.5525e084.svg";